export default "__VITE_ASSET__88eb2aeb__"